export const locale = {
    lang: 'es',
    data: {
        'MENU': {
            'MY_PROFILE' : 'Mi Perfil',
            'LOGOUT' : 'Desconectarse'
        }
    }
};